import { createSelector } from "reselect";
import { State } from "../state";

export const getLoginState = (state: State) => state.user;

export const getUser = createSelector(
  getLoginState,
  loginState => loginState.user
);

export const getUserId = createSelector(
  getUser,
  user => user.userId
);

export const getLoginErrorMessage = createSelector(
  getUser,
  user => user.errorMessage
);

export const getSSOApiUrl = (state: State) => state.config.ssoBaseApiUrl;

export const getSSORedirectUrl = (state: State) => state.config.ssoRedirectUrl;

export const getSSOSignoutUrl = (state: State) => state.config.ssoSignoutUrl;



// WEBPACK FOOTER //
// ./src/login/selector.ts